import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=58250482&scoped=true&"
import script from "./TemplateModal.vue?vue&type=script&lang=js&"
export * from "./TemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58250482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58250482')) {
      api.createRecord('58250482', component.options)
    } else {
      api.reload('58250482', component.options)
    }
    module.hot.accept("./TemplateModal.vue?vue&type=template&id=58250482&scoped=true&", function () {
      api.rerender('58250482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/TemplateModal.vue"
export default component.exports